import * as React from 'react'
import styled from 'styled-components'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'twitter-third-party-glyph-icon'

export function TwitterSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <g>
        <path
          fill="current"
          d="M17.927 15.351 23.511 9h-1.323l-4.849 5.515L13.467 9H9l5.856 8.34L9 24h1.323l5.12-5.824L19.534 24H24l-6.073-8.649Zm-1.812 2.062-.594-.83-4.72-6.608h2.032l3.81 5.332.593.83 4.953 6.933h-2.033l-4.041-5.657Z"
        />
      </g>
    </symbol>
  )
}

const TwitterStandaloneContent = standalone(TwitterSymbol, ID)

export const Twitter = styled(function TwitterStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-twitter">
      <TwitterStandaloneContent />
    </Icon>
  )
})``

export const TwitterLightweight = styled(function TwitterComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-twitter">
      {lightweight(ID)}
    </Icon>
  )
})``
